import type { ExpenseSettlementListRow } from '../domain/expenseTypes';
import type { PulledExpenseRow } from './expensesPullRemote';

export type WebExpensesSnapshotCache = {
  settlements: ExpenseSettlementListRow[];
  expenses: PulledExpenseRow[];
  fetchedAt: number;
};

let cached: WebExpensesSnapshotCache | null = null;

export function setWebExpensesSnapshotCache(payload: {
  settlements?: ExpenseSettlementListRow[];
  expenses?: PulledExpenseRow[];
}): void {
  cached = {
    settlements: Array.isArray(payload.settlements) ? payload.settlements : [],
    expenses: Array.isArray(payload.expenses) ? payload.expenses : [],
    fetchedAt: Date.now(),
  };
}

export function getWebExpensesSnapshotCache(): WebExpensesSnapshotCache | null {
  return cached;
}
